export const BASE_URL = 'https://backend.mercafacil.com/'

export const ENDPOINT_CLIENTES_PERDIDOS = 'kpis/clientes_perdidos'
export const ENDPOINT_FATURAMENTO = 'kpis/faturamento'
export const ENDPOINT_FATURAMENTO_DTA = 'kpis/faturamento_dta'
export const ENDPOINT_CUPONS = 'kpis/cupons'
export const ENDPOINT_CUPONS_POR_CLIENTE = 'kpis/cupons_por_cliente'
export const ENDPOINT_TICKET_MEDIO = 'kpis/ticket_medio'
export const ENDPOINT_CLIENTES_CADASTRADOS = 'kpis/clientes_cadastrados'
export const ENDPOINT_CLIENTES_ATIVOS = 'kpis/clientes_ativos'
export const ENDPOINT_PERCENTUAL_FATURAMENTO_FIDELIDADE = 'kpis/percentual_faturamento_fidelidade'
export const ENDPOINT_PERCENTUAL_CUPONS_FIDELIDADE = 'kpis/percentual_cupons_fidelidade'
export const ENDPOINT_ULTIMA_ATUALIZACAO = 'kpis/ultima_atualizacao'
export const ENDPOINT_UNIDADES = 'kpis/unidades'
export const ENDPOINT_PERCENTUAL_TICKET_MEDIO_FIDELIDADE = 'kpis/percentual_ticket_medio_fidelidade'
export const ENDPOINT_MEDIA_COMPRAS = 'kpis/media_compras'
export const ENDPOINT_GASTO_MEDIO = 'kpis/gasto_medio'
export const ENDPOINT_MEDIA_ITENS = 'kpis/itens_na_cesta'
export const ENDPOINT_QUANTIDADE_NA_CESTA = 'kpis/quantidade_na_cesta'
export const ENDPOINT_TOTAIS_VENDAS_PRODUTOS = 'kpis/totais_vendas_produtos'
export const ENDPOINT_TOTAIS_VENDAS_PRODUTOS_TOP = 'kpis/totais_vendas_produtos_top'
export const ENDPOINT_PRODUTOS_MAIS_VENDIDOS_TOP = 'kpis/listagem_produtos_mais_vendidos_top'
export const ENDPOINT_TOTAIS_FATURAMENTO_PRODUTOS = 'kpis/totais_faturamento_produtos'
export const ENDPOINT_TOTAIS_FATURAMENTO_PRODUTOS_TOP = 'kpis/totais_faturamento_produtos_top'
export const ENDPOINT_PRODUTOS_MAIS_FATURADOS_TOP = 'kpis/listagem_produtos_mais_faturados_top'
export const ENDPOINT_PRODUTOS_MENOS_VENDIDOS_TOP = 'kpis/listagem_produtos_menos_vendidos_top'
export const ENDPOINT_PRODUTOS_MENOS_FATURADOS_TOP = 'kpis/listagem_produtos_menos_faturados_top'
export const ENDPOINT_DATAS_LIMITES = 'kpis/datas_limites'
export const ENDPOINT_TOTAL_ITENS = 'kpis/itens'
export const ENDPOINT_BUSCA_PRODUTO = 'kpis/busca_produto'
export const ENDPOINT_BUSCA_CLIENTE = 'kpis/busca_cliente'
export const ENDPOINT_BUSCA_UNIDADE = 'kpis/busca_unidade'
export const ENDPOINT_BUSCA_CATEGORIA_PRODUTO = 'kpis/busca_categoria_produto'
export const ENDPOINT_PRECO_MEDIO = 'kpis/preco_medio'
export const ENDPOINT_DIAS_MAIORES_COMPRAS = 'kpis/dia_maior_compra'
export const ENDPOINT_HORAS_MAIORES_COMPRAS = 'kpis/hora_maior_compra'
export const ENDPOINT_DIAS_SEMANA_MAIORES_COMPRAS = 'kpis/dia_semana_maior_compra'
export const ENDPOINT_MELHORES_CLIENTES = 'kpis/listagem_melhores_clientes'
export const ENDPOINT_LISTA_INTERESSES_GENERO = 'kpis/listagem_interesses_por_genero'
export const ENDPOINT_LISTA_INTERESSES_IDADE = 'kpis/listagem_interesses_por_idade'
export const ENDPOINT_LISTA_INTERESSES_IDADE_VALOR = 'kpis/listagem_interesses_por_idade_valor'
export const ENDPOINT_RESULTADOS_ENCARTE = 'metrics/product_inserts'
export const ENDPOINT_LOGIN = 'users_api/login'
export const ENDPOINT_USERS = 'users_api/users'
export const ENDPOINT_RETENCAO = 'kpis/retencao'
export const ENDPOINT_CATEGORIAS_CLIENTES = 'kpis/listagem_categorias_clientes'
export const ENDPOINT_LISTA_CLIENTES_CADASTRADOS = 'kpis/listagem_clientes'
export const ENDPOINT_LISTA_CUPONS = 'kpis/listagem_cupons'
export const ENDPOINT_INICIO_FIDELIDADE = 'info/inicio_programa_fidelidade'
export const EMAIL_DOMAIN = '@mercafacil.me'
export const ENDPOINT_SEGMENTOS = 'segmentation_api/segments'
export const ENDPOINT_SEGMENTO_BY_ID = 'segmentation_api/segments/'
export const ENDPOINT_SEGMENTO_EVALUATE = 'segmentation_api/evaluate_segment'
export const ENDPOINT_MODELOS_SEGMENTO = 'segmentation_api/models'
export const ENDPOINT_MODELO_SEGMENTO_BY_ID = 'segmentation_api/models/'
export const ENDPOINT_VALIDATE_PRODUCTS = 'segmentation_api/validate_products'
export const ENDPOINT_SEGMENTATION_GET_CLIENTS = 'segmentation_api/get_clients'
export const ENDPOINT_UNITS = 'units_app/units'
export const ENDPOINT_UNITS_REVIEWS = 'units_app/units/reviews_statistics'
export const ENDPOINT_REVIEWS = 'reviews_api/reviews/'
export const ENDPOINT_LISTA_CLIENTES_COMPRA = 'kpis/listagem_clientes_pela_compra'
export const ENDPOINT_UNIT_COORDINATES = 'geo_api/unit_coordinates'
export const ENDPOINT_CLIENT_COORDINATES = 'geo_api/client_coordinates'
export const ENDPOINT_GEO_STATUS = 'geo_api/status'
export const ENDPOINT_CAMPANHAS = 'campaigns_api/campaigns'
export const ENDPOINT_CAMPANHAS_BY_ID = 'campaigns_api/campaigns/'
export const ENDPOINT_CAMPANHAS_CHAT = 'campaigns_api/chat/'
export const ENDPOINT_DUPLICATE_CAMPANHA = 'campaigns_api/duplicate_campaign/'
export const ENDPOINT_GET_SMS_CREDITS = 'campaigns_api/get_sms_credits'
export const ENDPOINT_GET_ACTIVE_CAMPAIGNS_QUANTITY = 'campaigns_api/get_active_campaigns_quantity'
export const ENDPOINT_GET_ACTIVE_CAMPAIGNS_QUARTER = 'campaigns_api/get_active_campaigns_quarter'
export const ENDPOINT_CAMPAIGN_MESSAGE_HISTORY = 'campaigns_api/messages_history/'
export const ENDPOINT_CAMPAIGN_SUMMARY = 'campaigns_api/summary/'
export const ENDPOINT_SCHEDULED_MESSAGES_QUANTITY = 'campaigns_api/get_scheduled_messages_quantity'
export const ENDPOINT_UPLOAD_IMAGE = 'campaigns_api/upload_image'
export const ENDPOINT_LISTAGEM_CLIENTES_RETENCAO_ATIVOS = 'kpis/listagem_clientes_retencao'
export const ENDPOINT_LISTAGEM_CLIENTES_RETENCAO_INATIVOS = 'kpis/listagem_clientes_retencao_churn'
export const ENDPOINT_CAMPAIGN_SMS = 'metrics/campaign_sms'
export const ENDPOINT_CLIENTS = 'users_api/clients'
export const ENDPOINT_PADRAO_CONSUMO = 'metrics/segment_products'
export const ENDPOINT_SMS_POR_PRODUTO = 'metrics/campaign_sms_products'
export const ENDPOINT_MPP = 'kpis/mpp'
export const ENDPOINT_BANNER = 'campaigns_api/banner'
export const ENDPOINT_EVOLUCAO_BASE_CLIENTES = 'kpis/evolucao_base_clientes'
export const ENDPOINT_RESULTADOS_CAMPANHA_PRIMEIRO_VALOR = 'metrics/campaign_sms_first_value'
export const ENDPOINT_ULTIMA_ATUALIZACAO_PRIMEIRO_VALOR = 'info/last_update'
export const ENDPOINT_CAMPAIGN_METRICS = 'metrics/campaigns'
export const ENDPOINT_CAMPAIGN_METRICS_REALTIME = 'metrics/campaigns_realtime'
export const ENDPOINT_CAMPAIGNS_COUNT = 'campaigns_api/count_campaigns'
export const ENDPOINT_MESSAGES_COUNT = 'campaigns_api/count_messages'
export const ENDPOINT_PERFORMANCE_OPERACIONAL = 'kpis/performance_operacional'
export const ENDPOINT_PERCENTUAL_CUPONS_IDENTIFICADAS = 'kpis/percentual_cupons_identificados_operadores'
export const ENDPOINT_PERCENTUAL_FATURAMENTO_IDENTIFICADO = 'kpis/percentual_faturamento_identificado_operadores'
export const ENDPOINT_DETALHES_OPERADOR = 'kpis/detalhes_operador'
export const ENDPOINT_PRODUCTS_TREE = 'products_api/tree'
export const ENDPOINT_CATEGORIES_TREE = 'products_api/category_tree'
export const ENDPOINT_PRODUCTS_SEARCH_LIST = 'products_api/products'
export const ENDPOINT_PRODUCTS_CHECK = 'products_api/check'
export const ENDPOINT_CATEGORIA_PRODUTO_SEARCH_LIST = 'categories_api/check'
export const ENDPOINT_OFFERS_SCHEDULE = 'offers_schedule_api'
export const ENDPOINT_DEPARTMENTS = 'departments_api/departments'
export const ENDPOINT_FLYERS = 'flyers_api/flyers'
export const ENDPOINT_NEW_SEGMENTATION = 'segmentation_api/v2'
export const ENDPOINT_COSTUMERS = 'customer_api'
export const ENDPOINT_COSTUMERS_CHECK = 'customer_api/check'
export const ENDPOINT_EVALUATE_SEGMENT = 'segmentation_api/v2/evaluate_segment'
export const ENDPOINT_SEARCH_LIST_CATEGORIES = 'categories_api/check'
export const LAST_UPDATE = 'info/last_update'
export const ENDPOINT_SIGNUPS = 'info/signups'
export const ENDPOINT_CAMPAIGNS_CALENDAR_METRICS = 'campaigns_api/metrics/calendar'
export const ENDPOINT_SEARCH_CATEGORIES = 'categories_api/search/'
export const ENDPOINT_COMPARATIVO_PRODUTOS = 'optimized_kpis/loyalty/comparison/'
export const ENDPOINT_PRODUCT_COMPARISONS = 'metrics/product_comparisons'
export const ENDPOINT_CATEGORY_COMPARISONS = 'metrics/category_comparisons'
export const ENDPOINT_CAMPAIGNS_SUGGESTIONS = 'campaigns_api/suggestions'
export const ENDPOINT_METRICS_UNITS_COMPARISION = 'metrics/units_comparison'
